export default __webpack_public_path__ + "static/recurring-879252ffed1e10a746405e40161b6d43.png";